import React from "react";
import ReactDOM from "react-dom";
import CloseCross from "../ui/CloseCross";

const PortalDrawer = ({ open, onClose, title, route = [], tripId, error, footer, actions, children }) =>
    ReactDOM.createPortal(
        <div className={`task-drawer${open ? " task-drawer--open" : ""}`} aria-hidden={!open}>
            <div className="task-drawer__overlay" onClick={onClose} aria-hidden="true" />

            <aside className="task-drawer__panel" role="dialog" aria-modal="true" aria-label={title}>
                <div className="task-drawer__header">
                    <h3 className="task-drawer__title">{title}</h3>
                    <CloseCross onClick={onClose} colour="black" />
                </div>

                <div className="task-drawer__body">
                    <div className="task-drawer__derived">
                        <div className="task-drawer__derived-item">
                            <label>Route</label>
                            <span>{route.length ? route.join(" – ") : "–"}</span>
                        </div>
                        <div className="task-drawer__derived-item">
                            <label>Trip ID</label>
                            <span>{tripId || "–"}</span>
                        </div>
                    </div>
                    {children}
                </div>

                {error && (
                    <p className="task-drawer__error" role="alert">
                        {error}
                    </p>
                )}
                {footer}
                <div className="task-drawer__actions">{actions}</div>
            </aside>
        </div>,
        document.body
    );

export default PortalDrawer;
